module.exports = __webpack_public_path__ + "media/components/assets/icons/liveAndVod-968740b4254f1e30e5208de70b7c719f.svg";